import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";

import GeoField from "~/components/Forms/DealerPassportForm2/Address/GeoField";
import Accordion from "~/components/Forms/DealerPassportForm2/UI/Accordion";
import DynamicFormField from "~/components/Forms/DealerPassportForm2/UI/DynamicFormField";
import IconAutoFill from "~/components/Icons/autoFill";
import Button from "~/shared/ui/Fields/Button";
import { addressFields } from "~/components/Forms/DealerPassportForm2/Address/helper";
import { usePermissions } from "~/shared/context/PermissionContext";

import s from "~/components/Forms/DealerPassportForm2/Address/Address.less";

interface AspAddressProps {
  isRu: boolean;
  allDisabled: boolean;
  dealerInfoAsp: any[];
  dealerCoordinatsAsp: any[];
  autoFillAddress: (prefix: string) => void;
  removeAspAddress: (index: number) => void;
  addAspAddress: () => void;
  aspList: number[];
}

const AspAddress: React.FC<AspAddressProps> = ({
  isRu,
  dealerInfoAsp,
  dealerCoordinatsAsp,
  autoFillAddress,
  removeAspAddress,
  addAspAddress,
  aspList,
  allDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.border}>
      <Accordion title={"Торговая точка АСП"}>
        {aspList.length > 0 &&
          aspList.map((aspIndex) => (
            <div key={`asp-${aspIndex}`} className={s.aspWrapper}>
              <div className={s.titleAsp}>
                {`Торговая точка АСП №${aspIndex}`}
              </div>

              {!allDisabled && (
                <div className={s.wrapperBtn}>
                  <Button
                    txtBtn={t("dealers.autoFill")}
                    onClick={() => autoFillAddress(`${aspIndex}-aspAddress`)}
                    customClassName={s.autoFillButtonAsp}
                  >
                    <IconAutoFill />
                  </Button>
                  <Button
                    txtBtn={"Удалить АСП"}
                    onClick={() => removeAspAddress(aspIndex)}
                    customClassName={s.autoFillButtonAsp}
                  />
                </div>
              )}

              <div className={s.wrapperBase}>
                <DynamicFormField
                  name={`${aspIndex}-aspAddressname`}
                  label={t("dealers.tradeName")}
                  type="text"
                  className={s.mainAddress}
                  disabled={allDisabled}
                />
                <DynamicFormField
                  name={`${aspIndex}-aspAddresslegalName`}
                  label={t("dealers.legalName")}
                  type="text"
                  className={s.mainAddress}
                  disabled={allDisabled}
                />
                <DynamicFormField
                  name={`${aspIndex}-aspAddressinn`}
                  label={t("dealers.inn")}
                  type="text"
                  mask="9999999999"
                  className={s.mainAddress}
                  disabled={allDisabled}
                />
                <DynamicFormField
                  name={`${aspIndex}-aspAddressfullAddress`}
                  label={t("dealers.fullAddress")}
                  type="text"
                  className={s.mainAddress}
                  disabled
                />

                {Object.entries(addressFields).map(
                  ([field, { type, parentField }]) => (
                    <div
                      key={`${aspIndex}-aspAddress${field}`}
                      className={clsx(s.item, {
                        [s.itemWidth]: field === "address",
                      })}
                    >
                      <GeoField
                        prefix={`${aspIndex}-aspAddress`}
                        dinamicPrefix={`${aspIndex}-aspAddress`}
                        field={field}
                        type={type}
                        parentField={parentField}
                        isRu={isRu}
                        allDisabled={allDisabled}
                      />
                    </div>
                  ),
                )}
                <DynamicFormField
                  name={`${aspIndex}-aspAddressoffice`}
                  label={t("dealers.office")}
                  type="text"
                  disabled={allDisabled}
                  className={clsx(s.item)}
                />
                <DynamicFormField
                  name={`${aspIndex}-aspAddressindex`}
                  label={t("dealers.index")}
                  type="text"
                  className={clsx(s.item)}
                  disabled
                />
              </div>

              <div className={s.coordinatsBottom}>
                <div className={s.title}>{"Географические координаты:"}</div>
                <div className={s.coordinatsWrapper}>
                  {dealerCoordinatsAsp.map((field) => (
                    <div key={field.name} className={clsx(s.itemCor)}>
                      <DynamicFormField
                        {...field}
                        name={`${aspIndex}-${field.name}`}
                        disabled={allDisabled}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className={s.borderSolo} />

              <div className={s.aspInfo}>
                {dealerInfoAsp.map((field) => (
                  <DynamicFormField
                    key={field.name}
                    {...field}
                    name={`${aspIndex}-${field.name}`}
                    disabled={allDisabled}
                  />
                ))}
              </div>
            </div>
          ))}

        <Button
          txtBtn={"Добавить АСП"}
          onClick={addAspAddress}
          customClassName={s.addBtn}
          disabled={allDisabled}
        />
      </Accordion>
    </div>
  );
};

export default AspAddress;
